import type { AdminDashboardQuery } from '@innovamat/glow-api-client';
import i18next from 'i18next';

function getRandomLastConnectionDate(): string {
  const now = new Date();
  const daysAgo = Math.floor(Math.random() * 30);
  const randomDate = new Date(now.getTime() - daysAgo * 24 * 60 * 60 * 1000);
  const year = randomDate.getFullYear();
  const month = (randomDate.getMonth() + 1).toString().padStart(2, '0');
  const day = randomDate.getDate().toString().padStart(2, '0');
  const hour = Math.floor(Math.random() * 24)
    .toString()
    .padStart(2, '0');
  const minute = Math.floor(Math.random() * 60)
    .toString()
    .padStart(2, '0');
  const second = Math.floor(Math.random() * 60)
    .toString()
    .padStart(2, '0');
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}

export const mockDataPE: AdminDashboardQuery = {
  adminDashboard: [
    {
      course: {
        courseName: i18next.t('1 Primaria'),
        courseOrder: 6,
      },
      classroom: 'Mercury',
      classroomId: 'b1e2c3d4-5f6a-7b8c-9d0e-1a2b3c4d5e6f',
      sessions: {
        completed: 1,
        total: 85,
        completed_laboratory: 0,
        completed_adventure: 0,
      },
      digitalPractice: {
        avgScore: null,
        studentsPerStrip: [0, 0, 0, 0],
        acquiredContent: 85,
      },
      students: {
        connectedPercentage: 0,
        timeSpent: 0,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Lucas',
        lastName: 'Smith',
      },
      tests: {
        hasPermission: false,
        numberOfAvailableTestReports: 0,
        rounds: [],
      },
    },
    {
      course: {
        courseName: i18next.t('1 Primaria'),
        courseOrder: 6,
      },
      classroom: 'Venus',
      classroomId: 'a7b6c5d4-e3f2-1a09-8b7c-6d5e4f3a2b1c',
      sessions: {
        completed: 61,
        total: 85,
        completed_laboratory: 43,
        completed_adventure: 17,
      },
      digitalPractice: {
        avgScore: 7.935202385000907,
        studentsPerStrip: [0, 1, 17, 3],
        acquiredContent: 44,
      },
      students: {
        connectedPercentage: 100,
        timeSpent: 2473,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Marta',
        lastName: 'Baker',
      },
      tests: {
        hasPermission: false,
        numberOfAvailableTestReports: 0,
        rounds: [],
      },
    },
    {
      course: {
        courseName: i18next.t('1 Primaria'),
        courseOrder: 6,
      },
      classroom: 'Earth',
      classroomId: 'c9d8e7f6-a5b4-3c2d-1e0f-9a8b7c6d5e4f',
      sessions: {
        completed: 11,
        total: 85,
        completed_laboratory: 11,
        completed_adventure: 0,
      },
      digitalPractice: {
        avgScore: 8.77,
        studentsPerStrip: [0, 0, 1, 0],
        acquiredContent: 50,
      },
      students: {
        connectedPercentage: 0,
        timeSpent: 0,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Ryan',
        lastName: 'Moreno',
      },
      tests: {
        hasPermission: false,
        numberOfAvailableTestReports: 0,
        rounds: [],
      },
    },
    {
      course: {
        courseName: i18next.t('2 Primaria'),
        courseOrder: 7,
      },
      classroom: 'Mars',
      classroomId: 'e1f2a3b4-c5d6-7e8f-9a0b-1c2d3e4f5a6b',
      sessions: {
        completed: 67,
        total: 88,
        completed_laboratory: 49,
        completed_adventure: 18,
      },
      digitalPractice: {
        avgScore: 6.508698710570665,
        studentsPerStrip: [2, 14, 10, 0],
        acquiredContent: 34,
      },
      students: {
        connectedPercentage: 0,
        timeSpent: 0,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Clara',
        lastName: 'Hernández',
      },
      tests: {
        hasPermission: false,
        numberOfAvailableTestReports: 0,
        rounds: [],
      },
    },
    {
      course: {
        courseName: i18next.t('2 Primaria'),
        courseOrder: 7,
      },
      classroom: 'Jupiter',
      classroomId: 'f7e6d5c4-b3a2-1c0d-9e8f-7a6b5c4d3e2f',
      sessions: {
        completed: 67,
        total: 88,
        completed_laboratory: 50,
        completed_adventure: 17,
      },
      digitalPractice: {
        avgScore: 7.297194848250163,
        studentsPerStrip: [1, 7, 18, 0],
        acquiredContent: 42,
      },
      students: {
        connectedPercentage: 0,
        timeSpent: 0,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Sofía',
        lastName: 'Martínez',
      },
      tests: {
        hasPermission: false,
        numberOfAvailableTestReports: 0,
        rounds: [],
      },
    },
    {
      course: {
        courseName: i18next.t('3 Primaria'),
        courseOrder: 8,
      },
      classroom: 'Saturn',
      classroomId: 'd3c2b1a0-9e8f-7d6c-5b4a-3e2f1a0b9c8d',
      sessions: {
        completed: 37,
        total: 88,
        completed_laboratory: 25,
        completed_adventure: 12,
      },
      digitalPractice: {
        avgScore: 7.14082489474504,
        studentsPerStrip: [1, 8, 16, 0],
        acquiredContent: 79,
      },
      students: {
        connectedPercentage: 100,
        timeSpent: 1246.44,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'David',
        lastName: 'White',
      },
      tests: {
        hasPermission: true,
        numberOfAvailableTestReports: 1,
        rounds: [
          {
            roundName: 'FAKE.MOCK_EXAM_01.title',
            participation: {
              total: 25,
              completed: 21,
            },
          },
        ],
      },
    },
    {
      course: {
        courseName: i18next.t('3 Primaria'),
        courseOrder: 8,
      },
      classroom: 'Uranus',
      classroomId: 'e8f7d6c5-b4a3-2c1d-0e9f-8a7b6c5d4e3f',
      sessions: {
        completed: 62,
        total: 88,
        completed_laboratory: 48,
        completed_adventure: 14,
      },
      digitalPractice: {
        avgScore: 6.961693971730715,
        studentsPerStrip: [0, 11, 12, 0],
        acquiredContent: 37,
      },
      students: {
        connectedPercentage: 96,
        timeSpent: 893.2727272727273,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Oliver',
        lastName: 'Johnson',
      },
      tests: {
        hasPermission: true,
        numberOfAvailableTestReports: 1,
        rounds: [
          {
            roundName: 'FAKE.MOCK_EXAM_01.title',
            participation: {
              total: 23,
              completed: 22,
            },
          },
        ],
      },
    },
    {
      course: {
        courseName: i18next.t('3 Primaria'),
        courseOrder: 8,
      },
      classroom: 'Pluto',
      classroomId: 'a1b2c3d4-e5f6-7a8b-9c0d-1e2f3a4b5c6d',
      sessions: {
        completed: 3,
        total: 88,
        completed_laboratory: 3,
        completed_adventure: 0,
      },
      digitalPractice: {
        avgScore: null,
        studentsPerStrip: [0, 0, 0, 0],
        acquiredContent: 43,
      },
      students: {
        connectedPercentage: 0,
        timeSpent: 0,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Lucía',
        lastName: 'López',
      },
      tests: {
        hasPermission: true,
        numberOfAvailableTestReports: 0,
        rounds: [],
      },
    },
    {
      course: {
        courseName: i18next.t('4 Primaria'),
        courseOrder: 9,
      },
      classroom: 'Luna',
      classroomId: 'b7c6d5e4-f3a2-1b0c-9d8e-7f6a5b4c3d2e',
      sessions: {
        completed: 49,
        total: 88,
        completed_laboratory: 43,
        completed_adventure: 6,
      },
      digitalPractice: {
        avgScore: 6.901886128539126,
        studentsPerStrip: [0, 12, 11, 0],
        acquiredContent: 60,
      },
      students: {
        connectedPercentage: 100,
        timeSpent: 3234.521739130435,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Liam',
        lastName: 'Castro',
      },
      tests: {
        hasPermission: true,
        numberOfAvailableTestReports: 1,
        rounds: [
          {
            roundName: 'FAKE.MOCK_EXAM_01.title',
            participation: {
              total: 23,
              completed: 21,
            },
          },
        ],
      },
    },
    {
      course: {
        courseName: i18next.t('4 Primaria'),
        courseOrder: 9,
      },
      classroom: 'Io',
      classroomId: 'c4d3e2f1-a0b9-8c7d-6e5f-4a3b2c1d0e9f',
      sessions: {
        completed: 50,
        total: 88,
        completed_laboratory: 40,
        completed_adventure: 10,
      },
      digitalPractice: {
        avgScore: 6.390565741027045,
        studentsPerStrip: [1, 16, 7, 0],
        acquiredContent: 68,
      },
      students: {
        connectedPercentage: 96,
        timeSpent: 2608.4347826086955,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'James',
        lastName: 'Miller',
      },
      tests: {
        hasPermission: true,
        numberOfAvailableTestReports: 1,
        rounds: [
          {
            roundName: 'FAKE.MOCK_EXAM_01.title',
            participation: {
              total: 24,
              completed: 22,
            },
          },
        ],
      },
    },
    {
      course: {
        courseName: i18next.t('5 Primaria'),
        courseOrder: 10,
      },
      classroom: 'Europa',
      classroomId: 'e2f1a0b9-c8d7-6e5f-4a3b-2c1d0e9f8a7b',
      sessions: {
        completed: 57,
        total: 88,
        completed_laboratory: 41,
        completed_adventure: 16,
      },
      digitalPractice: {
        avgScore: 6.943153394966293,
        studentsPerStrip: [0, 13, 13, 0],
        acquiredContent: 71,
      },
      students: {
        connectedPercentage: 39,
        timeSpent: 1454.9,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Marina',
        lastName: 'Torres',
      },
      tests: {
        hasPermission: true,
        numberOfAvailableTestReports: 1,
        rounds: [
          {
            roundName: 'FAKE.MOCK_EXAM_01.title',
            participation: {
              total: 26,
              completed: 25,
            },
          },
        ],
      },
    },
    {
      course: {
        courseName: i18next.t('5 Primaria'),
        courseOrder: 10,
      },
      classroom: 'Ganymede',
      classroomId: 'f3a2b1c0-d9e8-7f6a-5b4c-3d2e1f0a9b8c',
      sessions: {
        completed: 59,
        total: 88,
        completed_laboratory: 39,
        completed_adventure: 20,
      },
      digitalPractice: {
        avgScore: 7.317948149186034,
        studentsPerStrip: [0, 7, 18, 0],
        acquiredContent: 51,
      },
      students: {
        connectedPercentage: 100,
        timeSpent: 1609.24,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Emily',
        lastName: 'Davis',
      },
      tests: {
        hasPermission: true,
        numberOfAvailableTestReports: 1,
        rounds: [
          {
            roundName: 'FAKE.MOCK_EXAM_01.title',
            participation: {
              total: 25,
              completed: 24,
            },
          },
        ],
      },
    },
    {
      course: {
        courseName: i18next.t('6 Primaria'),
        courseOrder: 11,
      },
      classroom: 'Callisto',
      classroomId: 'd8e7f6a5-b4c3-2d1e-0f9a-8b7c6d5e4f3a',
      sessions: {
        completed: 59,
        total: 88,
        completed_laboratory: 42,
        completed_adventure: 17,
      },
      digitalPractice: {
        avgScore: 7.365238088485267,
        studentsPerStrip: [0, 6, 20, 0],
        acquiredContent: 86,
      },
      students: {
        connectedPercentage: 67,
        timeSpent: 666.7777777777778,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Lucas',
        lastName: 'Navarro',
      },
      tests: {
        hasPermission: true,
        numberOfAvailableTestReports: 1,
        rounds: [
          {
            roundName: 'FAKE.MOCK_EXAM_01.title',
            participation: {
              total: 27,
              completed: 23,
            },
          },
        ],
      },
    },
    {
      course: {
        courseName: i18next.t('6 Primaria'),
        courseOrder: 11,
      },
      classroom: 'Europa',
      classroomId: 'e8f7d6c5-b4a3-2c1d-0e9f-8a7b6c5d4e3f',
      sessions: {
        completed: 58,
        total: 88,
        completed_laboratory: 42,
        completed_adventure: 16,
      },
      digitalPractice: {
        avgScore: 7.318849701242059,
        studentsPerStrip: [0, 10, 15, 1],
        acquiredContent: 82,
      },
      students: {
        connectedPercentage: 35,
        timeSpent: 500.8888888888889,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Pablo',
        lastName: 'Wilson',
      },
      tests: {
        hasPermission: true,
        numberOfAvailableTestReports: 2,
        rounds: [
          {
            roundName: 'FAKE.MOCK_EXAM_01.title',
            participation: {
              total: 26,
              completed: 0,
            },
          },
          {
            roundName: 'FAKE.CONMAT_02.title',
            participation: {
              total: 26,
              completed: 21,
            },
          },
        ],
      },
    },
  ],
};

export const mockDataEY: AdminDashboardQuery = {
  adminDashboard: [
    {
      course: {
        courseName: i18next.t('I3'),
        courseOrder: 3,
      },
      classroom: 'Iguana',
      classroomId: 'b2c1d3e4-5f6a-7b8c-9d0e-1a2b3c4d5e6f',
      sessions: {
        completed: 0,
        total: 20,
        completed_laboratory: 0,
        completed_adventure: 0,
      },
      digitalPractice: {
        avgScore: 8.07916043795417,
        studentsPerStrip: [0, 3, 5, 2],
        acquiredContent: 43,
      },
      students: {
        connectedPercentage: 6,
        timeSpent: 1135,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Julia',
        lastName: 'Moreno',
      },
      tests: {
        hasPermission: false,
        numberOfAvailableTestReports: 0,
        rounds: [],
      },
    },
    {
      course: {
        courseName: i18next.t('I5'),
        courseOrder: 5,
      },
      classroom: 'Hippo',
      classroomId: 'a3b4c5d6-e7f8-1a09-8b7c-6d5e4f3a2b1c',
      sessions: {
        completed: 14,
        total: 34,
        completed_laboratory: 0,
        completed_adventure: 0,
      },
      digitalPractice: {
        avgScore: 7.291053435720757,
        studentsPerStrip: [0, 4, 16, 0],
        acquiredContent: 51,
      },
      students: {
        connectedPercentage: 95,
        timeSpent: 1182.0526315789473,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Oliver',
        lastName: 'Smith',
      },
      tests: {
        hasPermission: false,
        numberOfAvailableTestReports: 0,
        rounds: [],
      },
    },
    {
      course: {
        courseName: i18next.t('I4'),
        courseOrder: 4,
      },
      classroom: 'Zebra',
      classroomId: 'c5d6e7f8-a9b0-3c2d-1e0f-9a8b7c6d5e4f',
      sessions: {
        completed: 14,
        total: 28,
        completed_laboratory: 0,
        completed_adventure: 0,
      },
      digitalPractice: {
        avgScore: 7.4158526164396745,
        studentsPerStrip: [0, 4, 18, 0],
        acquiredContent: 72,
      },
      students: {
        connectedPercentage: 64,
        timeSpent: 414.5,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Marina',
        lastName: 'Torres',
      },
      tests: {
        hasPermission: false,
        numberOfAvailableTestReports: 0,
        rounds: [],
      },
    },
  ],
};

export const mockDataSE: AdminDashboardQuery = {
  adminDashboard: [
    {
      course: {
        courseName: i18next.t('1 SE'),
        courseOrder: 13,
      },
      classroom: 'Surf',
      classroomId: 'd1e2f3a4-b5c6-7d8e-9f0a-1b2c3d4e5f6a',
      sessions: {
        completed: 5,
        total: 22,
        completed_laboratory: 1,
        completed_adventure: 0,
      },
      digitalPractice: {
        avgScore: 7.8,
        studentsPerStrip: [1, 2, 6, 1],
        acquiredContent: 38,
      },
      students: {
        connectedPercentage: 12,
        timeSpent: 900,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Lucas',
        lastName: 'Fernández',
      },
      tests: {
        hasPermission: false,
        numberOfAvailableTestReports: 0,
        rounds: [],
      },
    },
    {
      course: {
        courseName: i18next.t('2 SE'),
        courseOrder: 14,
      },
      classroom: 'Pizza',
      classroomId: 'e2f3a4b5-c6d7-8e9f-0a1b-2c3d4e5f6a7b',
      sessions: {
        completed: 18,
        total: 36,
        completed_laboratory: 2,
        completed_adventure: 1,
      },
      digitalPractice: {
        avgScore: 7.5,
        studentsPerStrip: [0, 5, 14, 2],
        acquiredContent: 55,
      },
      students: {
        connectedPercentage: 88,
        timeSpent: 1300,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Emma',
        lastName: 'Lopez',
      },
      tests: {
        hasPermission: false,
        numberOfAvailableTestReports: 0,
        rounds: [],
      },
    },
    {
      course: {
        courseName: i18next.t('3 SE'),
        courseOrder: 15,
      },
      classroom: 'Sneakers',
      classroomId: 'f3a4b5c6-d7e8-9f0a-1b2c-3d4e5f6a7b8c',
      sessions: {
        completed: 12,
        total: 30,
        completed_laboratory: 1,
        completed_adventure: 1,
      },
      digitalPractice: {
        avgScore: 7.9,
        studentsPerStrip: [0, 3, 15, 1],
        acquiredContent: 60,
      },
      students: {
        connectedPercentage: 70,
        timeSpent: 500,
      },
      teachers: {
        lastTeacherAccess: getRandomLastConnectionDate(),
        firstName: 'Sophie',
        lastName: 'Smith',
      },
      tests: {
        hasPermission: false,
        numberOfAvailableTestReports: 0,
        rounds: [],
      },
    },
  ],
};
